import { render, staticRenderFns } from "./AdminAnnouncementCreate.vue?vue&type=template&id=089df350&"
import script from "./AdminAnnouncementCreate.vue?vue&type=script&lang=js&"
export * from "./AdminAnnouncementCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports